// extracted by mini-css-extract-plugin
export var applicationInfoContainer = "bS_hL";
export var applicationInfoSection1 = "bS_hM";
export var applicationInfoSection2 = "bS_hN";
export var applicationInfoTagline = "bS_hP";